export const percentFormatCollection = (Cant: number, CantDiv: number) => {
  return CantDiv ? Math.round((100 * Cant) / CantDiv) + "%" : "";
};
